import React, { useState, useEffect } from 'react';
import { Truck, Settings, CheckCircle, AlertCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminShipping = () => {
  const [stats, setStats] = useState({ ups: 0, hfd: 0, private: 0, pickup: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const r = await axios.get(`${API}/admin/orders`);
        const orders = r.data;
        let ups = 0, hfd = 0, priv = 0, pickup = 0;
        for (const o of orders) {
          if (o.pickup_provider === 'ups' || (!o.pickup_provider && o.shipping_method === 'pickup')) ups++;
          else if (o.pickup_provider === 'hfd') hfd++;
          if (o.payment_method === 'private') priv++;
          if (o.shipping_method === 'pickup') pickup++;
        }
        setStats({ ups, hfd, private: priv, pickup });
      } catch (e) {}
    };
    fetchStats();
  }, []);

  return (
    <div dir="rtl" data-testid="admin-shipping-section">
      <h2 className="text-xl font-black text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
        <Truck className="w-5 h-5 inline ml-2" />ניהול משלוחים
      </h2>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-3 mb-6">
        <div className="bg-white rounded-xl p-4 border border-stone-200 text-center">
          <p className="text-2xl font-black text-[#D97706]">{stats.ups}</p>
          <p className="text-xs text-stone-500 font-bold">UPS</p>
        </div>
        <div className="bg-white rounded-xl p-4 border border-stone-200 text-center">
          <p className="text-2xl font-black text-blue-600">{stats.hfd}</p>
          <p className="text-xs text-stone-500 font-bold">HFD</p>
        </div>
        <div className="bg-white rounded-xl p-4 border border-stone-200 text-center">
          <p className="text-2xl font-black text-purple-600">{stats.private}</p>
          <p className="text-xs text-stone-500 font-bold">פרטי</p>
        </div>
        <div className="bg-white rounded-xl p-4 border border-stone-200 text-center">
          <p className="text-2xl font-black text-green-600">{stats.pickup}</p>
          <p className="text-xs text-stone-500 font-bold">נקודות איסוף</p>
        </div>
      </div>

      {/* Shipping Providers */}
      <div className="space-y-4">
        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center"><span className="font-black text-amber-700 text-sm">UPS</span></div>
              <div>
                <h3 className="font-bold text-sm">Ship.co.il - UPS Israel</h3>
                <p className="text-xs text-stone-400">משלוחי UPS ונקודות איסוף</p>
              </div>
            </div>
            <span className="bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1"><CheckCircle className="w-3 h-3" /> מחובר</span>
          </div>
          <div className="grid grid-cols-3 gap-2 text-xs">
            <div className="bg-stone-50 rounded-lg p-2"><span className="text-stone-400">עלות משלוח בית:</span><span className="font-bold text-stone-700 mr-1">₪37</span></div>
            <div className="bg-stone-50 rounded-lg p-2"><span className="text-stone-400">עלות נקודת איסוף:</span><span className="font-bold text-stone-700 mr-1">₪37</span></div>
            <div className="bg-stone-50 rounded-lg p-2"><span className="text-stone-400">עלות מזומן:</span><span className="font-bold text-stone-700 mr-1">₪70</span></div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center"><span className="font-black text-blue-700 text-sm">HFD</span></div>
              <div>
                <h3 className="font-bold text-sm">HFD - משלוחים</h3>
                <p className="text-xs text-stone-400">משלוחי HFD ונקודות איסוף</p>
              </div>
            </div>
            <span className="bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1"><CheckCircle className="w-3 h-3" /> מחובר</span>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div className="bg-stone-50 rounded-lg p-2"><span className="text-stone-400">קוד רגיל:</span><span className="font-bold text-stone-700 mr-1">16 (כפול אוברנייט)</span></div>
            <div className="bg-stone-50 rounded-lg p-2"><span className="text-stone-400">קוד מזומן:</span><span className="font-bold text-stone-700 mr-1">22 (כפול גובינא)</span></div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-4 border border-stone-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center"><span className="font-black text-purple-700 text-xs">פרטי</span></div>
              <div>
                <h3 className="font-bold text-sm">משלוח פרטי</h3>
                <p className="text-xs text-stone-400">ללא עלות משלוח, ללא מע"מ</p>
              </div>
            </div>
            <span className="bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1"><CheckCircle className="w-3 h-3" /> פעיל</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminShipping;
